import React, { FC, useEffect, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { useHistoryNew, modalLayer, getCouponsInfo } from '@utils'
import { format } from '@dt/fe-utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { checkMCBenifit } from 'common/utils/member'
import GetCardDetail from '../GetCardDetail'
import mktController from 'controllers/mktController'
import './index.scss'

import IconRecom from '@img/member/icon-recom.png'
import cardBg from '@img/member/card-bg.png'

interface IProps {
  cardInfo: any;
  isHas?: boolean;
  couponMap?: any;
  isBestDiscount?: boolean;
  hasDetail?: boolean;
  onClick?: () => void;
}

const GetCardItem: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const {
    cardInfo,
    isHas,
    couponMap,
    isBestDiscount,
    hasDetail = true,
    onClick
  } = props
  const [receiveCnt, setReceiveCnt] = useState<number>(0)
  const [renewCnt, setRenewCnt] = useState<number>(0)
  const [timeCnt, setTimeCnt] = useState<number>(0)
  const couponPolicys = useMemo(() => {
    if (cardInfo && cardInfo.isSendCoupon && cardInfo.couponPolicys.length > 0) {
      return keyBy(cardInfo.couponPolicys, (item: any) => {
        if (item.sendType === 'action') {
          return `${item.sendType}_${item.sendValue}`
        } else {
          return item.sendType
        }
      })
    } else {
      return {}
    }
  }, [cardInfo])
  const extraInfo = useMemo(() => {
    return cardInfo.extra ? cardInfo.extra : {}
  }, [cardInfo])
  const buyCard = (e: any) => {
    if (onClick) return
    e.stopPropagation()
    mktController.checkLogin(history).then(() => {
      history.push(`/iCard/cardOpen/open/${cardInfo.cardId}`)
    })
  }
  const goDetail = () => {
    modalLayer(GetCardDetail, { cardInfo: cardInfo, isHas: isHas ? 1 : 0 }).then((res: any) => {
      if (res.error) {
        mktController.goBack(history)
      } else {
        if (res.url) {
          if (res.url === 'login') {
            mktController.checkLogin(history)
          } else {
            history.push(res.url)
          }
        }
      }
    }, () => { })
  }
  useEffect(() => {
    if (couponMap && Object.keys(couponMap).length > 0 && Object.keys(couponPolicys).length > 0) {
      if (couponPolicys) {
        if (couponPolicys.action_renewAndReceive) {
          setReceiveCnt(getCouponsInfo(couponPolicys.action_renewAndReceive.coupons, 'cnt', couponMap))
          setRenewCnt(getCouponsInfo(couponPolicys.action_renewAndReceive.coupons, 'cnt', couponMap))
        } else {
          if (couponPolicys.action_receive) {
            setReceiveCnt(getCouponsInfo(couponPolicys.action_receive.coupons, 'cnt', couponMap))
          }
          if (couponPolicys.action_renew) {
            setRenewCnt(getCouponsInfo(couponPolicys.action_renew.coupons, 'cnt', couponMap))
          }
        }
      }
      if (couponPolicys && couponPolicys.time) {
        setTimeCnt(getCouponsInfo(couponPolicys.time.coupons, 'cnt', couponMap))
      }
    }
  }, [couponMap, couponPolicys])
  const { benifitRecharge, benifitIntegral, benifitMallRate, benifitMealPrice, benifitMealRate, benifitMallPrice, benifitCoupon, benifitNum } = checkMCBenifit(cardInfo)
  const isTwoRowLayout = benifitNum >= 5
  return (
    <div
      className='get-card-face' style={{
        color: extraInfo.fontColor || '#B8B8B8',
        borderRightColor: extraInfo?.fontColor || '#B8B8B8'
      }}
      data-cypid='mmgClickMCard'
      onClick={() => {
        if (onClick) {
          onClick()
          return
        }
        if (hasDetail) {
          goDetail()
          return
        }
      }}
    >
      <div
        className='mci-content'
        style={{ backgroundImage: `Url(${cardInfo.cover || cardBg})` }}
      >
        <div className='mci-content-l'>
          <div className='mci-header'>
            <div className='name'>{cardInfo.cardName}</div>
            <div className={`legal-right${isTwoRowLayout ? ' legal-right-two' : ''}`}>
              {benifitRecharge && <span>{i18n.t('mkt.member.allowRe')}</span>}
              {benifitIntegral && <span>{i18n.t('mkt.member.integralGet')}</span>}
              {isTwoRowLayout && <div />}
              {benifitMealPrice &&
                <span>{i18n.t('order.meals')} {i18n.t('checkout.memberPrice')}</span>}
              {
                benifitMealRate &&
                  <span>{cardInfo?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')} {format.toDiscount('discountRate', cardInfo.discountValue)}</span>
              }
              {
                benifitMallPrice &&
                  <span>{i18n.t('order.mall')} {i18n.t('checkout.memberPrice')}</span>
              }
              {
                benifitMallRate && !!cardInfo.mallDiscountValue &&
                  <span>{cardInfo?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')} {format.toDiscount('discountRate', cardInfo.mallDiscountValue)}</span>
              }
              {benifitCoupon && <span>{i18n.t('mkt.member.couponSend')}</span>}
            </div>
          </div>
          {
            !isHas &&
              <div className='operation-btn'>
                {
                  cardInfo.type === 'paid'
                    ? (
                      <div
                        className='recharge'
                        style={{
                          backgroundColor: extraInfo.btnColor || '#B8B8B8 ',
                          color: extraInfo.btnFontColor || '#251E1E'
                        }}
                        data-cypid='mmgBuyMCard'
                        onClick={buyCard}
                      >
                        <div className='btn-text'>{i18n.t('mkt.member.buy')}</div>
                      </div>)
                    : (
                      <div
                        className='recharge'
                        data-cypid='mmgBuyMCard'
                        style={{
                          backgroundColor: extraInfo.btnColor || '#B8B8B8 ',
                          color: extraInfo.btnFontColor || '#251E1E'
                        }}
                        onClick={buyCard}
                      >
                        <div className='btn-text'>{i18n.t('mkt.member.freeClaim')}</div>
                      </div>)
                }
              </div>
          }
        </div>
      </div>
      {
        isBestDiscount &&
          <div className='recom-show'>
            <img src={IconRecom} alt='' />
          </div>
      }
      {
        hasDetail &&
          <div className='detail-info'>
            <span className='info'>
              {cardInfo.allowAgainLoad || cardInfo.allowCustomizeLoad ? i18n.t('mkt.member.allowRe') : i18n.t('mkt.member.notAllowRe')}
              {cardInfo.isSendCoupon && receiveCnt > 0 && `, ${i18n.t('mkt.member.openCardTip3', { number: receiveCnt })}`}
              {cardInfo.isSendCoupon && renewCnt > 0 && `, ${i18n.t('mkt.member.openCardTip4', { number: renewCnt })}`}
              {cardInfo.isSendCoupon && timeCnt > 0 && `, ${i18n.t('mkt.member.getCouponTip1', { time: i18n.t(`mkt.member.sendTime${couponPolicys.time.sendValue}`), number: timeCnt })}`}
            </span>
            <span className='detail'>{i18n.t('mkt.common.seeDetails')}</span>
          </div>
      }
    </div>
  )
}

export default observer(GetCardItem)
